import { Dispatch } from "redux";
import { getWalletsSuccess, getWalletFailure, getWalletsRequest } from "../store/modules/wallet/actions";
import api from "./api";

export const fetchWallets = async (dispatch: Dispatch<any>, async?: boolean) => {
  console.log('fetching wallets...', Date.now())

  if (async) {
    dispatch(getWalletsRequest());
  }

  try {
    const response = await api.get('/wallet/list');

    dispatch(getWalletsSuccess(response.data));
  } catch (err) {
    dispatch(getWalletFailure('error'));
  }
}
